import React, { useState } from "react";
import { searchUsersByEmail } from "../firebase/Users";
import { UserList } from "../components/UserList";

function SearchUser() {
  const [email, setEmail] = useState("");
  const [queryResult, setQueryResult] = useState(null);

  return (
    <div>
      <div className="card">
        <div className="justify-content-center d-flex">
          <h2>Search User</h2>
        </div>
      </div>
      <div className="row justify-content-center d-flex">
        <form
          className="form-inline "
          onSubmit={async (e) => {
            e.preventDefault();
            const userList = await searchUsersByEmail(email);
            setQueryResult(userList);
          }}
        >
          <label className="ml-2">User Email:</label>
          <input
            type="text"
            className="form-control m-2"
            id="email"
            placeholder="Enter User Email"
            name="email"
            onChange={(e) => setEmail(e.target.value.toLowerCase())}
          />

          <button type="submit" className="btn btn-primary m-2">
            Search
          </button>
        </form>
      </div>
      <div
        className="card border-top-0 rounded-0"
        style={{ position: "inherit" }}
      >
        <div className="card-body py-2 justify-content-center d-flex">
          <div className="card-title font-weight-bold m-0">Result</div>
        </div>
      </div>
      {queryResult != null && (
        <div
          className="card border-top-0 rounded-0"
          style={{ position: "inherit" }}
        >
          <div className="card-body py-2 justify-content-center d-flex">
            <div className="card-title font-weight-bold m-0">
              Query Results here..
              {queryResult.length > 0 ? (
                <UserList queryResult={queryResult} />
              ) : (
                <div>No user found</div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchUser;
